var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "分类管理",
        visible: _vm.dialogVisiClass,
        width: "700px",
        "before-close": _vm.handleCancel,
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisiClass = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "dialog-body"
        },
        [
          _vm.flatList.length > 0
            ? _c(
                "div",
                { staticClass: "tree-list" },
                _vm._l(_vm.flatList, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: item._key,
                      staticClass: "tree-item",
                      class: {
                        "drag-over":
                          _vm.dragOverIndex === index &&
                          _vm.dragIndex !== index,
                        "drag-source": _vm.dragIndex === index,
                        editing: item._editing
                      },
                      style: { paddingLeft: 12 + item.depth * 28 + "px" },
                      on: {
                        dragover: function($event) {
                          return _vm.onDragOver($event, index)
                        },
                        drop: function($event) {
                          return _vm.onDrop($event, index)
                        },
                        dragend: _vm.onDragEnd
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "drag-handle",
                          class: { "no-drag": item.node._isNew },
                          attrs: { draggable: "true" },
                          on: {
                            dragstart: function($event) {
                              return _vm.onDragStart($event, index)
                            }
                          }
                        },
                        [_vm._v("☰")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "expand-icon",
                          class: { placeholder: !item.hasChildren },
                          on: {
                            click: function($event) {
                              item.hasChildren && _vm.toggleExpand(item.node)
                            }
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                item.hasChildren
                                  ? item.expanded
                                    ? "▼"
                                    : "▶"
                                  : ""
                              ) +
                              " "
                          )
                        ]
                      ),
                      item._editing
                        ? _c(
                            "el-form",
                            {
                              ref: "editForm_" + item._key,
                              refInFor: true,
                              staticClass: "edit-form-inline",
                              attrs: { model: item.node, rules: _vm.editRules }
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "edit-form-item",
                                  attrs: { prop: "typeName" }
                                },
                                [
                                  _c("el-input", {
                                    ref: "editInput",
                                    refInFor: true,
                                    attrs: {
                                      size: "mini",
                                      maxlength: "12",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        item.node.typeName = item.node.typeName.replace(
                                          /\s/g,
                                          ""
                                        )
                                      }
                                    },
                                    model: {
                                      value: item.node.typeName,
                                      callback: function($$v) {
                                        _vm.$set(item.node, "typeName", $$v)
                                      },
                                      expression: "item.node.typeName"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _c(
                            "span",
                            {
                              staticClass: "node-name",
                              class: { deleted: item.node._isDeleted },
                              on: {
                                dblclick: function($event) {
                                  return _vm.startEdit(item)
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(item.node.typeName) + " ")]
                          ),
                      item._editing
                        ? _c(
                            "span",
                            { staticClass: "actions" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "text" },
                                  on: {
                                    click: function($event) {
                                      return _vm.finishEdit(item)
                                    }
                                  }
                                },
                                [_vm._v("确定")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "text" },
                                  on: {
                                    click: function($event) {
                                      return _vm.cancelEdit(item)
                                    }
                                  }
                                },
                                [_vm._v("取消")]
                              )
                            ],
                            1
                          )
                        : _c("span", { staticClass: "actions" }, [
                            item.depth < 2
                              ? _c("i", {
                                  staticClass: "el-icon-plus",
                                  attrs: { title: "新增下级分类" },
                                  on: {
                                    click: function($event) {
                                      return _vm.addChild(item.node)
                                    }
                                  }
                                })
                              : _vm._e(),
                            _c("i", {
                              staticClass: "el-icon-edit",
                              attrs: { title: "编辑" },
                              on: {
                                click: function($event) {
                                  return _vm.startEdit(item)
                                }
                              }
                            }),
                            _c("i", {
                              staticClass: "el-icon-delete",
                              attrs: { title: "删除" },
                              on: {
                                click: function($event) {
                                  return _vm.deleteNode(item.node)
                                }
                              }
                            })
                          ])
                    ],
                    1
                  )
                }),
                0
              )
            : _c("div", { staticClass: "empty-tip" }, [_vm._v("暂无分类数据")]),
          _c(
            "div",
            { staticClass: "add-first-area" },
            [
              !_vm.showAddFirstInput
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        type: "text",
                        icon: "el-icon-plus",
                        size: "small"
                      },
                      on: { click: _vm.openAddFirstInput }
                    },
                    [_vm._v("新增一级分类")]
                  )
                : _vm._e(),
              _vm.showAddFirstInput
                ? _c(
                    "div",
                    { staticClass: "add-first-input-row" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "addFirstForm",
                          staticClass: "add-first-form",
                          attrs: {
                            model: _vm.addFirstForm,
                            rules: _vm.addFirstRules
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "name" } },
                            [
                              _c("el-input", {
                                ref: "addFirstInput",
                                attrs: {
                                  size: "mini",
                                  maxlength: "12",
                                  "show-word-limit": "",
                                  clearable: "",
                                  placeholder: "输入分类名称"
                                },
                                on: {
                                  input: function($event) {
                                    _vm.addFirstForm.name = _vm.addFirstForm.name.replace(
                                      /\s/g,
                                      ""
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.addFirstForm.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.addFirstForm, "name", $$v)
                                  },
                                  expression: "addFirstForm.name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "span",
                        { staticClass: "action-btns" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "text" },
                              on: { click: _vm.confirmAddFirstLevel }
                            },
                            [_vm._v("确定")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "text" },
                              on: { click: _vm.cancelAddFirstLevel }
                            },
                            [_vm._v("取消")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleCancel } },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary", loading: _vm.saving },
              on: { click: _vm.handleSave }
            },
            [_vm._v("保存")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }